var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_1158)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_198_1158",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_198_1158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0005C32 7.16393 24.8365 0.000488281 16 0.000488281C7.16344 0.000488281 0 7.16393 0 16.0005C0 23.9865 5.85097 30.6059 13.5 31.8061V20.6255H9.43751V16.0005H13.5V12.4755C13.5 8.46549 15.8887 6.25049 19.5435 6.25049C21.294 6.25049 23.1251 6.56299 23.1251 6.56299V10.5005H21.1075C19.1199 10.5005 18.5 11.7338 18.5 12.9991V16.0005H22.9375L22.2281 20.6255H18.5V31.8061C26.1491 30.6059 32 23.9865 32 16.0005Z",
    fill: "#520A76"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_1158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/face-book.5a18a09a59c9fcab956f842b16a10f33.svg";
export { ForwardRef as ReactComponent };